<!-- MODAL (overlay + caja) -->
<div class="survey-overlay" *ngIf="encuestaEnabled && isSurveyVisible" (click)="closeSurvey()">
  <div class="survey-box" (click)="$event.stopPropagation()">
    <button class="survey-close" type="button" (click)="closeSurvey()">×</button>

    <img src="assets/images/icons/bds_ic_information.svg" alt="bds ic information" />

    <h2 class="survey-title">¡Ayúdanos a mejorar!</h2>

    <p class="survey-text">
      Para nosotros es muy importante tu opinión. Te pedimos que por favor,
      evalúes estos tres puntos en base al último despacho.
    </p>

    <!-- 1 -->
    <div class="survey-block">
      <p class="survey-question">Despacho (Entrega)</p>
      <div class="survey-stars">
        <button
          type="button"
          class="star-btn"
          *ngFor="let star of stars"
          [class.star-btn--on]="isStarOn('delivery', star)"
          (click)="setRating('delivery', star)"
        >
          ★
        </button>
      </div>
    </div>

    <!-- 2 -->
    <div class="survey-block">
      <p class="survey-question">Atención del operador</p>
      <div class="survey-stars">
        <button
          type="button"
          class="star-btn"
          *ngFor="let star of stars"
          [class.star-btn--on]="isStarOn('operator', star)"
          (click)="setRating('operator', star)"
        >
          ★
        </button>
      </div>
    </div>

    <!-- 3 -->
    <div class="survey-block">
      <p class="survey-question">Producto</p>
      <div class="survey-stars">
        <button
          type="button"
          class="star-btn"
          *ngFor="let star of stars"
          [class.star-btn--on]="isStarOn('product', star)"
          (click)="setRating('product', star)"
        >
          ★
        </button>
      </div>
    </div>

    <!-- Firma -->
    <div class="survey-block">
      <p class="survey-question">¿Qué tan fácil fue firmar digitalmente tu guía?</p>

      <div class="survey-stars">
        <button
          type="button"
          class="star-btn"
          *ngFor="let star of stars"
          [class.star-btn--on]="isStarOn('signature', star)"
          (click)="setRating('signature', star)"
        >
          ★
        </button>
      </div>

      <div class="survey-scale">
        <span>Muy difícil</span>
        <span>Difícil</span>
        <span>Neutral</span>
        <span>Fácil</span>
        <span>Muy fácil</span>
      </div>
    </div>

    <!-- Comentario -->
<!-- Comentario -->
<div class="survey-comments">
  <p class="survey-question">¿Qué podríamos mejorar?</p>

  <textarea
    maxlength="180"
    placeholder="Déjanos tus comentarios o sugerencias."
    [value]="comment"
    (input)="comment = ($any($event.target).value || '')"
  ></textarea>

  <span class="survey-counter">{{ comment.length }} / 180</span>

  <!-- Mensaje de validación -->
  <!-- <small class="survey-error" *ngIf="comment.trim().length === 0 && canSubmit() === false">
    El comentario es obligatorio.
  </small> -->
</div>

    <button
      class="survey-submit"
      type="button"
      [disabled]="!canSubmit() || isSubmitting"
      [class.survey-submit--ready]="canSubmit() && !isSubmitting"
      (click)="submitSurvey()"
    >
      {{ isSubmitting ? 'Enviando...' : 'Enviar' }}
    </button>
  </div>
</div>


